'use client';

import PortableText, { TextVariant } from '@ui/Text/PortableText';
import { FrequencySwitchProps } from '.';
import { usePricingFrequency } from '../PricingMain/PricingFrequencyContext';

export default function FrequencySwitchMobile({ data }: FrequencySwitchProps) {
  const { isYearlyFrequency, setIsYearlyFrequency } = usePricingFrequency();
  const firstHeroPricing = data?.[0];
  if (!data || !firstHeroPricing?.switcher) {
    return null;
  }
  const switcherRGB = firstHeroPricing.switcherColor?.rgb;

  return (
    <div className="flex items-center justify-center gap-4">
      <PortableText
        className="font-medium uppercase text-blue-700"
        content={firstHeroPricing.switcherLeftLabel}
        variant={TextVariant.TextLabel}
      />

      <label className="inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          checked={isYearlyFrequency}
          onChange={() => setIsYearlyFrequency(!isYearlyFrequency)}
          className="peer sr-only"
        />
        <div
          style={{
            backgroundColor: `rgba(${switcherRGB?.r},${switcherRGB?.g},${switcherRGB?.b},${switcherRGB?.a})`,
          }}
          className="peer relative h-5 w-9 rounded-full bg-gray-300 after:absolute after:start-[2px] 
                after:top-[2px] after:h-4 after:w-4 after:rounded-full after:border after:border-gray-300
                 after:bg-white after:transition-all
                 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-hidden
                 rtl:peer-checked:after:-translate-x-full"
        ></div>
      </label>
      <PortableText
        className="font-medium uppercase text-blue-700"
        content={firstHeroPricing.switcherRightLabel}
        variant={TextVariant.TextLabel}
      />
    </div>
  );
}
